export const STORE_STORAGE_KEY = 'utk_selected_store';
export const STORE_SELECTION_SOURCES = {
    MANUAL: 'manual',
    AUTO: 'auto',
};
export const SET_STORE_BUTTON_CLASS = 'store-locator__set-store-btn';
export const SET_STORE_BUTTON_LABEL = 'Set as My Store';
export const MY_STORE_BUTTON_LABEL = 'My Store';
export const STORE_MANUALLY_SELECTED_EVENT = 'untuckit:store_manually_selected';
